

























































































































































































































































































import {
  BSidebar,
  BButton,
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  BSpinner,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { required, min, max } from "@validations";
import {
  CreateInformationAdditionnelle,
  InformationAdditionnellePreview,
} from "@/api/models/informationAdditionnelle/informationAdditionnelle";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { TypeEntiteEnum } from "@/api/models/enums/typeEntiteEnum";
import { IconesEnum } from "@/api/models/enums/iconesEnum";
import { CouleursEnum } from "@/api/models/enums/couleursEnum";
import { VueSelect } from "vue-select";
import { Parametre } from "@/api/models/parametres/parametre";
import { Fonction } from "@/api/models/authorization/fonctions/fonction";
import { Groupe } from "@/api/models/groupes/groupe";
import store from "@/store";
import { EnumTenants } from "@/api/models/enums/enumTenants";
import appSettings from "@/appSettings";

@Component({
  components: {
    BSidebar,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BFormCheckboxGroup,
    VueSelect,
    BFormFile,
  },
  name: "create-information-additionnelle",
})
export default class CreateInformationAdditionnelleModal extends Vue {
  @Prop({ required: false }) cibleType?: TypeEntiteEnum;
  @Prop({ required: false }) cibleId?: string;
  @Prop({ required: false, default: "Ajout d'une information additionnelle" })
  @Prop({ required: true, type: Boolean })
  title!: string;
  loading = false;

  required = required;
  min = min;
  max = max;

  searchQuery = "";
  totalCount = 0;
  searchEntitesItems: any[] = [];

  entitiesOptions = Object.values(TypeEntiteEnum);
  entitiesOptionsEnum = TypeEntiteEnum;
  allowedTags = store.getters['user/ai_allowed_tags'];

  icones: string[] = [];
  iconesEnum = IconesEnum;

  couleurs: string[] = [];
  couleursEnum = CouleursEnum;

  couleurSelected: string = "";
  iconeSelected: string = "";

  listFonctions: { text: string; value: string }[] = [];
  listGroupes: { text: string; value: string }[] = [];
  assigneFonctions: { text: string; value: string }[] = [];
  motifOptions: string[] = [];
  perimetreOptions: string[] = [];

  tenantId = appSettings.getTenantId();
  tenants = EnumTenants;

  newInformationAdditionnelle: CreateInformationAdditionnelle = {
    fichiers: [],
  };
  previewInformationAdditionelle: InformationAdditionnellePreview = {};
  fichiersUploaded = [];

  previewsAccess = {};

  get isAcist() {
    return this.tenantId === this.tenants.Acist;
  }

  getIconeKey(iconeValue: any) {
    return Object.keys(this.iconesEnum)[
      Object.values(this.iconesEnum).indexOf(iconeValue)
    ];
  }

  getCouleurKey(couleurValue: any) {
    return Object.keys(this.couleursEnum)[
      Object.values(this.couleursEnum).indexOf(couleurValue)
    ];
  }

  async created() {
    await this.loadIconesAndCouleurs();
    
    if (this.cibleType && this.cibleId) {
      this.newInformationAdditionnelle.cibleId = this.cibleId;
      this.newInformationAdditionnelle.cibleType = this.cibleType;
      await this.loadFonctions();
      await this.loadGroupes();
    }

    if (this.isAcist) {
      await this.loadMotifOptions();
      await this.loadPerimetreOptions();
      await this.loadAssigneFonctions();
    }
  }

  async loadIconesAndCouleurs() {
    // Load icones filter
    let iconesToRemove: string[] = [];
    let iconesOnly: string[] = [];
    await this.$http.myressif.parametres
      .getByNom('informationsadditionnelles_icones')
      .then((response: Parametre) => {
        if (response?.valeur) {
          const valeur = JSON.parse(response.valeur);
          iconesToRemove = valeur['remove'] || [];
          iconesOnly = valeur['only'] || [];
        }
      })
      .catch(() => {});

    const allIcones = Object.entries(this.iconesEnum);
    this.icones = allIcones
      .filter(([key]) => 
        (iconesOnly.length ? iconesOnly.includes(key) : true) &&
        (iconesToRemove.length ? !iconesToRemove.includes(key) : true)
      )
      .map(([, value]) => value);

    // Load couleurs filter
    let couleursToRemove: string[] = [];
    let couleursOnly: string[] = [];
    await this.$http.myressif.parametres
      .getByNom('informationsadditionnelles_couleurs')
      .then((response: Parametre) => {
        if (response?.valeur) {
          const valeur = JSON.parse(response.valeur);
          couleursToRemove = valeur['remove'] || [];
          couleursOnly = valeur['only'] || [];
        }
      })
      .catch(() => {});

    const allCouleurs = Object.entries(this.couleursEnum);
    this.couleurs = allCouleurs
      .filter(([key]) => 
        (couleursOnly.length ? couleursOnly.includes(key) : true) &&
        (couleursToRemove.length ? !couleursToRemove.includes(key) : true)
      )
      .map(([, value]) => value);
  }

  async loadGroupes() {
    var parametreNom = "";
    switch (this.newInformationAdditionnelle.cibleType) {
      case TypeEntiteEnum.UTILISATEUR:
        parametreNom = "informationsadditionnelles_groupes_utilisateur";
        break;
      case TypeEntiteEnum.ENTREPRISE:
        parametreNom = "informationsadditionnelles_groupes_adherent";
        break;
      case TypeEntiteEnum.FOURNISSEUR:
        parametreNom = "informationsadditionnelles_groupes_fournisseur";
        break;
      case TypeEntiteEnum.PARTENAIRE:
        parametreNom = "informationsadditionnelles_groupes_partenaire";
      default:
        break;
    }
    

    var toRemove: string[] = [];
    var only: string[] = [];

    await this.$http.myressif.parametres
      .getByNom(parametreNom)
      .then((response: Parametre) => {
        var valeur = response ? JSON.parse(response.valeur) : [];
        toRemove = valeur["remove"];
        only = valeur["only"];
      });

      await this.$http.myressif.groupes
      .paginatedList(1, 100)
      .then((response: PaginatedList<Groupe>) => {
        var test = response.items.filter(
          (g) =>
            (only ? only.includes(g.id) : true) &&
            (toRemove ? !toRemove.includes(g.id) : true)
        );
        this.listGroupes = test.map(({ libelle: text, id: value }) => ({
          text,
          value,
        }));      
      });
  }

  async loadFonctions() {
    var parametreNom = "";
    switch (this.newInformationAdditionnelle.cibleType) {
      case TypeEntiteEnum.UTILISATEUR:
        parametreNom = "informationsadditionnelles_droits_utilisateur";
        break;
      case TypeEntiteEnum.ENTREPRISE:
        parametreNom = "informationsadditionnelles_droits_adherent";
        break;
      case TypeEntiteEnum.FOURNISSEUR:
        parametreNom = "informationsadditionnelles_droits_fournisseur";
        break;
      case TypeEntiteEnum.PARTENAIRE:
        parametreNom = "informationsadditionnelles_droits_partenaire";
      default:
        break;
    }

    var toRemove: string[] = [];
    var only: string[] = [];

    await this.$http.myressif.parametres
      .getByNom(parametreNom)
      .then((response: Parametre) => {
        var res = response ? JSON.parse(response.valeur) : [];
        toRemove = res["remove"];
        only = res["only"];
      });

    await this.$http.myressif.fonctions
      .paginatedList(1, 100)
      .then((response: PaginatedList<Fonction>) => {
        var test = response.items.filter(
          (f) =>
            (only ? only.includes(f.code) : true) &&
            (toRemove ? !toRemove.includes(f.code) : true)
        );
        this.listFonctions = test.map(({ libelle: text, id: value }) => ({
          text,
          value,
        }));
      });
  }

  @Watch("newInformationAdditionnelle.motif")
  onMotifChanged(newValue: string | undefined) {
    if (!newValue) {
      this.newInformationAdditionnelle.perimetre = undefined;
    }
  }

  async loadMotifOptions() {
    const parametreNom = "informationsadditionnelles_motif";
    await this.$http.myressif.parametres
      .getByNom(parametreNom)
      .then((response: Parametre) => {
        if (response?.valeur) {
          this.motifOptions = JSON.parse(response.valeur) || [];
        }
      })
      .catch(() => {
        this.motifOptions = [];
      });
  }

  async loadPerimetreOptions() {
    const parametreNom = "informationsadditionnelles_perimetre";
    await this.$http.myressif.parametres
      .getByNom(parametreNom)
      .then((response: Parametre) => {
        if (response?.valeur) {
          this.perimetreOptions = JSON.parse(response.valeur) || [];
        }
      })
      .catch(() => {
        this.perimetreOptions = [];
      });
  }

  async loadAssigneFonctions() {
    await this.$http.myressif.fonctions
      .paginatedList(1, 100)
      .then((response: PaginatedList<Fonction>) => {
        this.assigneFonctions = response.items.map(
          ({ libelle: text, id: value }) => ({ text, value })
        );
      })
      .catch(() => {
        this.assigneFonctions = [];
      });
  }

  async previewRights() {
    this.previewInformationAdditionelle.cibleId =
      this.newInformationAdditionnelle.cibleId;
    this.previewInformationAdditionelle.cibleType =
      this.newInformationAdditionnelle.cibleType;
    this.previewInformationAdditionelle.groupesAllowed =
      this.newInformationAdditionnelle.groupesAllowed;
    this.previewInformationAdditionelle.fonctionsAllowed =
      this.newInformationAdditionnelle.fonctionsAllowed;

    await this.$http.myressif.informationsAdditionnelles
      .previewRights(this.previewInformationAdditionelle)
      .then(
        async (response: any) => {
          this.previewsAccess = Object.entries(response);
          this.$bvModal.show("modal-preview-right");
        
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.informationsAdditionnelles
      .post(this.newInformationAdditionnelle)
      .then(
        async (response: any) => {
          this.$emit("info-added");
          successAlert.fire({
            timer: 3500,
            title: "Ajout d'une information additionnelle",
            text: "Information ajoutée avec succès",
          });
          this.newInformationAdditionnelle = {};
          this.newInformationAdditionnelle.cibleId = this.cibleId;
          this.newInformationAdditionnelle.cibleType = this.cibleType;
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(async () => {
        this.loading = false;
      });
  }
}
